import { useEffect, useRef, useState } from 'react';
import { useOutsideClick } from '@/hooks/click-outside-hook';
import { Chip, Stack, TextField, Typography } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { MuscleTag } from '@/generated';
import { TagAdder } from '@/components/TagAdder';

interface MuscleTagEditorProps {
  tagEditMode: boolean;
  muscleTags: Array<MuscleTag>;
  tagCreated: (tagName: string) => void;
  tagUpdated: (tag: MuscleTag) => void;
  tagRemoved: (muscleTag: MuscleTag) => void;
  tagClicked?: (muscleTag: MuscleTag) => void;
}

export const MuscleTagEditor = (props: MuscleTagEditorProps) => {
  return (
    <>
      {props.muscleTags
        ?.sort((a, b) => a.name.localeCompare(b.name))
        .map((bzt) =>
          props.tagEditMode ? (
            <EditableTag key={bzt.id} tag={bzt} tagRemoved={props.tagRemoved} tagUpdated={props.tagUpdated} />
          ) : (
            <ClickableTag key={bzt.id} tag={bzt} tagClicked={props.tagClicked} />
          ),
        )}
      {props.tagEditMode ? <TagAdder tagCreated={(name) => props.tagCreated(name)} /> : undefined}
    </>
  );
};

interface EditableTagProps {
  tag: MuscleTag;
  tagUpdated: (tag: MuscleTag) => void;
  tagRemoved: (tag: MuscleTag) => void;
}

interface ClickableTagProps {
  tag: MuscleTag;
  tagClicked?: (muscleTag: MuscleTag) => void;
}

export const ClickableTag = (props: ClickableTagProps) => {
  return (
    <Chip
      onClick={() => {
        if (props.tagClicked) props.tagClicked(props.tag);
      }}
      sx={{ m: 0.2 }}
      label={<Typography style={{ padding: 5, overflow: 'hidden' }}>{props.tag.name}</Typography>}
      style={{ backgroundColor: '#606C38' }}
    ></Chip>
  );
};

export const EditableTag = (props: EditableTagProps) => {
  const [editMode, setEditMode] = useState<boolean | undefined>(undefined);
  const [tagName, setTagName] = useState<string>(props.tag.name);
  const elementRef = useRef<HTMLHeadingElement | null>(null);

  useOutsideClick(elementRef.current, () => setEditMode(false));

  useEffect(() => {
    if (editMode === false) {
      props.tagUpdated({ ...props.tag, name: tagName });
    }
  }, [editMode]);

  return (
    <Chip
      ref={elementRef}
      sx={{ m: 0.2 }}
      onClick={() => {
        setEditMode(true);
      }}
      label={
        editMode ? (
          <Stack direction={'row'} gap={1} alignItems={'center'}>
            <Clear
              onClick={() => {
                props.tagRemoved(props.tag);
              }}
            />
            <TextField autoFocus={true} style={{ width: 100 }} variant="standard" value={tagName} onChange={(e) => setTagName(e.target.value)} />
          </Stack>
        ) : (
          <Typography style={{ padding: 5, overflow: 'hidden' }}>{props.tag.name}</Typography>
        )
      }
      style={{ backgroundColor: '#606C38' }}
    ></Chip>
  );
};
